import { IconVariant } from "@/components/atoms";
import { QuickSetupModal } from "./QuickSetupModal";

interface ReadSetupGuideModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  documentationUrl: string;
  pdfUrl?: string;
  featuredIcon?: {
    name: string;
    background?: string;
    className?: string;
    isCustom?: boolean;
    variant?: IconVariant;
  };
}

export const ReadSetupGuideModal = ({
  open,
  onClose,
  title,
  subtitle,
  documentationUrl,
  pdfUrl,
  featuredIcon,
}: ReadSetupGuideModalProps) => {
  return (
    <QuickSetupModal
      open={open}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      variant="web-large"
      content={{
        type: "setup-guide",
        documentationUrl,
        pdfUrl,
      }}
      className="max-h-[90vh]"
      featuredIcon={featuredIcon}
    />
  );
};
